/*
 * pdp-fx.js: shared helpers for the Totem Compass product page sections (pdp-*). Loaded by snippets/pdp-fx.liquid,
 * after ttm-fx.js (the Compass engine). Safe to include more than once.
 *
 *   TTMPDP.lights.take(el)   takes over one engine Compass ([data-ttmx-compass]) so a section can paint its own
 *                            Bond Lights (any bearing, any colour), Crystal and collected friends, or hand it back
 *                            to an engine preset (Smart Group rainbow, Quick Bond...) at any time.
 *   TTMPDP.seen(el, fn)      calls fn(true/false) as el comes on and off screen.
 *   TTMPDP.bearing(a, b)     screen bearing from point a to point b, degrees clockwise from straight up.
 *   Canvas backgrounds:      .pdpx-bg--stars canvas, .pdpx-bg--pcb canvas (drawn here, paused off screen).
 */
(function () {
  if (window.TTMPDP && window.TTMPDP.lights) return;
  var T = window.TTMPDP = window.TTMPDP || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  T.reduce = reduce;
  var SVGNS = 'http://www.w3.org/2000/svg';

  T.seen = function (el, fn, margin) {
    if (!('IntersectionObserver' in window)) { fn(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { fn(e.isIntersecting); }); }, { rootMargin: margin || '80px' }).observe(el);
  };
  T.bearing = function (a, b) { var d = Math.atan2(b[0] - a[0], -(b[1] - a[1])) * 180 / Math.PI; return (d + 360) % 360; };
  T.ready = function (el, fn) {
    // waits until the engine has built the Compass (ttm-fx.js runs first, but sections can render later in the editor)
    var n = 0;
    (function tryIt() { if (el.ttmxCompass) fn(el.ttmxCompass); else if (++n < 120) setTimeout(tryIt, 100); })();
  };

  /* ---------------------------------------------------------------- */
  /* Lights: paint a Compass by hand, with the app's ring geometry      */
  /* ---------------------------------------------------------------- */
  var RING_R = 161, LED = 6;
  function polar(r, deg) { var a = deg * Math.PI / 180; return [r * Math.sin(a), -r * Math.cos(a)]; }
  function arcPath(r, a1, a2) {
    var sweep = a2 - a1; if (sweep <= 0.05) sweep = 0.05; if (sweep >= 359.9) sweep = 359.9;
    var p1 = polar(r, a1), p2 = polar(r, a1 + sweep);
    return 'M ' + p1[0].toFixed(2) + ' ' + p1[1].toFixed(2) + ' A ' + r + ' ' + r + ' 0 ' + (sweep > 180 ? 1 : 0) + ' 1 ' + p2[0].toFixed(2) + ' ' + p2[1].toFixed(2);
  }
  function rgb(h) { h = String(h || '#fff').replace('#', ''); if (h.length === 3) h = h.replace(/(.)/g, '$1$1'); var n = parseInt(h.slice(0, 6), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function mix(a, b, t) { var x = rgb(a), y = rgb(b); return 'rgb(' + Math.round(x[0] + (y[0] - x[0]) * t) + ',' + Math.round(x[1] + (y[1] - x[1]) * t) + ',' + Math.round(x[2] + (y[2] - x[2]) * t) + ')'; }
  T.arcPath = arcPath; T.mix = mix;

  function Painter(c) {
    this.c = c; this.mode = 'engine'; this.paths = [];
    var proto = Object.getPrototypeOf(c), self = this;
    this.proto = proto;
    c.draw = function (now, still) { if (self.mode === 'engine') proto.draw.call(c, now, still); };
    this.g = document.createElementNS(SVGNS, 'g');
    this.g.setAttribute('data-pdp-arcs', '');
    if (c.arcG) c.arcG.appendChild(this.g);
  }
  Painter.prototype.engine = function (state, opts) {
    this.mode = 'engine';
    this.g.style.display = 'none';
    this.c.set(state, opts);
    this.proto.draw.call(this.c, performance.now(), reduce);
  };
  Painter.prototype.custom = function () {
    if (this.mode === 'custom') return;
    this.mode = 'custom';
    this.g.style.display = '';
    (this.c.pool || []).forEach(function (p) { p.style.display = 'none'; });
    var el = this.c.el;
    el.setAttribute('data-orient', 'hold'); this.c.orient = 'hold';
    el.style.setProperty('--ttmx-spin', '0deg'); this.c.spin = '0.00';
    (this.c.facets || []).forEach(function (f) { f.setAttribute('opacity', '0'); });
  };
  // frame: { arcs: [{ c, a, w (LEDs), o, r }], crystal: [colour, 0..1], slots: [[colour, 0..1], ...up to 8] }
  Painter.prototype.paint = function (f) {
    this.custom();
    var c = this.c, arcs = f.arcs || [], i;
    for (i = 0; i < arcs.length; i++) {
      var a = arcs[i], p = this.paths[i];
      if (!p) { p = document.createElementNS(SVGNS, 'path'); p.setAttribute('fill', 'none'); p.setAttribute('stroke-width', '12'); p.setAttribute('stroke-linecap', 'round'); this.g.appendChild(p); this.paths.push(p); }
      var o = a.o === undefined ? 1 : a.o;
      if (o <= 0.01) { p.style.display = 'none'; continue; }
      var h = Math.max(0.5, a.w) * LED / 2;
      p.style.display = '';
      p.setAttribute('d', arcPath(a.r || RING_R, a.a - h, a.a + h));
      p.setAttribute('stroke', a.c);
      p.setAttribute('stroke-opacity', o.toFixed(3));
    }
    for (; i < this.paths.length; i++) this.paths[i].style.display = 'none';
    var slots = f.slots || [], any = false, k;
    for (k = 0; k < 8; k++) if (slots[k] && slots[k][1] > 0.01) any = true;
    var cr = f.crystal || ['#E31FFF', 1], cc = cr[0], ci = Math.max(0, Math.min(1, cr[1])), lit = !any && ci > 0.02;
    if (c.kite) c.kite.style.display = lit ? '' : 'none';
    if (c.kiteFill) { c.kiteFill.setAttribute('fill', cc); c.kiteFill.setAttribute('fill-opacity', (0.18 + 0.82 * ci).toFixed(3)); }
    if (c.kiteGlow) { c.kiteGlow.setAttribute('fill', cc); c.kiteGlow.setAttribute('opacity', lit ? (0.55 * ci).toFixed(3) : '0'); }
    c.el.style.setProperty('--ttmx-kc', lit ? cc : '#16161b');
    c.el.style.setProperty('--ttmx-ki', lit ? ci.toFixed(3) : '0');
    for (k = 0; k < (c.slots || []).length; k++) {
      var s = slots[k], so = s ? Math.max(0, Math.min(1, s[1])) : 0;
      c.slots[k].setAttribute('opacity', so.toFixed(3));
      if (c.slotGlow[k]) { c.slotGlow[k].setAttribute('opacity', (so * 0.85).toFixed(3)); if (s) c.slotGlow[k].setAttribute('fill', s[0]); }
      if (s && c.slotStops[k]) c.slotStops[k].forEach(function (st, j) { st.setAttribute('stop-color', j === 0 ? mix(s[0], '#ffffff', 0.6) : s[0]); });
    }
  };
  T.lights = {
    take: function (el, fn) { T.ready(el, function (c) { if (!c.__pdp) c.__pdp = new Painter(c); fn(c.__pdp); }); }
  };

  /* ---------------------------------------------------------------- */
  /* Canvas backgrounds                                                */
  /* ---------------------------------------------------------------- */
  function hash(n) { var x = Math.sin(n * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); }
  function CanvasBg(cv, kind) {
    this.cv = cv; this.kind = kind; this.ctx = cv.getContext('2d'); this.on = false; this.t0 = performance.now();
    var self = this;
    this.size();
    window.addEventListener('resize', function () { clearTimeout(self.rt); self.rt = setTimeout(function () { self.size(); self.frame(performance.now()); }, 200); });
    T.seen(cv, function (v) { self.on = v; if (v && !reduce) self.loop(); });
    this.frame(performance.now());
  }
  CanvasBg.prototype.size = function () {
    // phones: 1x pixels (it's a soft background), and nothing is re-made unless the size really changed. iOS fires
    // resize as its toolbar slides while you scroll; re-allocating every background canvas (and a fresh full-size board
    // for the circuit) each time is the kind of memory churn that makes iOS reload the page (round 37)
    var r = this.cv.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ? 1 : 1.5);
    var w = Math.max(10, r.width), h = Math.max(10, r.height), pw = Math.round(w * dpr), ph = Math.round(h * dpr);
    if (this.cv.width === pw && Math.abs(this.cv.height - ph) < 2 && (this.stars || this.traces)) return;
    this.w = w; this.h = h;
    this.cv.width = pw; this.cv.height = ph;
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (this.kind === 'stars') this.makeStars(); else this.makePcb();
  };
  CanvasBg.prototype.loop = function () {
    if (this.raf) return;
    var self = this, last = 0;
    function step(now) {
      self.raf = 0;
      if (!self.on) return;
      if (now - last > 32) { last = now; self.frame(now); }   // about 30 fps is plenty for a background
      self.raf = requestAnimationFrame(step);
    }
    this.raf = requestAnimationFrame(step);
  };
  CanvasBg.prototype.makeStars = function () {
    var n = Math.round(this.w * this.h / 2600), s = [];
    for (var i = 0; i < n; i++) s.push({ x: hash(i + 1) * this.w, y: hash(i + 77) * this.h, r: 0.4 + Math.pow(hash(i + 13), 3) * 1.5, ph: hash(i + 5) * 6.28, sp: 0.6 + hash(i + 9) * 2.2, v: 2 + hash(i + 3) * 6, c: hash(i + 21) < 0.12 ? '249,179,239' : hash(i + 21) < 0.2 ? '160,220,255' : '255,255,255' });
    this.stars = s;
    // a few satellites crossing slowly, each with a soft blink (they're what your Totem is listening to)
    this.sats = [0, 1, 2].map(function (k) { return { y0: 0.12 + 0.22 * k, dy: (k % 2 ? -1 : 1) * 0.08, sp: 0.012 + 0.006 * k, ph: k * 0.37 }; });
  };
  CanvasBg.prototype.makePcb = function () {
    // traces on a 24 px grid: each walks a few steps, turning 45 or 90 degrees, and ends in a pad
    var g = 24, cols = Math.ceil(this.w / g) + 2, rows = Math.ceil(this.h / g) + 2, n = Math.round(cols * rows / 26), tr = [];
    var dirs = [[1, 0], [1, 1], [0, 1], [-1, 1], [-1, 0], [-1, -1], [0, -1], [1, -1]];
    for (var i = 0; i < n; i++) {
      var x = Math.floor(hash(i * 3 + 1) * cols), y = Math.floor(hash(i * 3 + 2) * rows), d = Math.floor(hash(i * 3 + 3) * 4) * 2, pts = [[x * g, y * g]];
      var segs = 2 + Math.floor(hash(i + 400) * 4);
      for (var k = 0; k < segs; k++) {
        var len = 2 + Math.floor(hash(i * 7 + k) * 6);
        x += dirs[d][0] * len; y += dirs[d][1] * len; pts.push([x * g, y * g]);
        d = (d + (hash(i * 11 + k) < 0.5 ? 1 : 7)) % 8;
      }
      var L = 0; for (k = 1; k < pts.length; k++) L += Math.hypot(pts[k][0] - pts[k - 1][0], pts[k][1] - pts[k - 1][1]);
      tr.push({ p: pts, L: L, ph: hash(i + 900), sp: 0.08 + hash(i + 901) * 0.12, hot: hash(i + 902) < 0.34, col: hash(i + 903) < 0.5 ? '242,60,212' : '32,214,255' });
    }
    this.traces = tr;
    // draw the static board once
    var off = this.board || document.createElement('canvas'); off.width = this.cv.width; off.height = this.cv.height;
    var o = off.getContext('2d'), dpr = this.cv.width / this.w; o.setTransform(dpr, 0, 0, dpr, 0, 0);
    var dark = this.cv.getAttribute('data-tone') === 'dark';
    o.lineWidth = 1.4; o.lineJoin = 'round'; o.strokeStyle = dark ? 'rgba(255,255,255,.07)' : 'rgba(96,59,234,.11)'; o.fillStyle = o.strokeStyle;
    tr.forEach(function (t) {
      o.beginPath(); o.moveTo(t.p[0][0], t.p[0][1]); for (var k = 1; k < t.p.length; k++) o.lineTo(t.p[k][0], t.p[k][1]); o.stroke();
      var e = t.p[t.p.length - 1], s = t.p[0];
      o.beginPath(); o.arc(e[0], e[1], 3.4, 0, 6.283); o.fill();
      o.beginPath(); o.arc(s[0], s[1], 2.2, 0, 6.283); o.stroke();
    });
    this.board = off;
  };
  function along(t, d) {
    for (var k = 1; k < t.p.length; k++) {
      var a = t.p[k - 1], b = t.p[k], l = Math.hypot(b[0] - a[0], b[1] - a[1]);
      if (d <= l) return [a[0] + (b[0] - a[0]) * d / l, a[1] + (b[1] - a[1]) * d / l];
      d -= l;
    }
    return t.p[t.p.length - 1];
  }
  CanvasBg.prototype.frame = function (now) {
    var x = this.ctx, t = reduce ? 4 : (now - this.t0) / 1000;
    x.clearRect(0, 0, this.w, this.h);
    if (this.kind === 'stars') {
      var w = this.w, h = this.h;
      this.stars.forEach(function (s) {
        var a = 0.35 + 0.65 * (0.5 + 0.5 * Math.sin(t * s.sp + s.ph));
        var px = ((s.x - t * s.v) % w + w) % w;
        x.fillStyle = 'rgba(' + s.c + ',' + (a * 0.85).toFixed(3) + ')';
        x.beginPath(); x.arc(px, s.y, s.r, 0, 6.283); x.fill();
      });
      this.sats.forEach(function (s) {
        var p = ((t * s.sp + s.ph) % 1.3) - 0.15, px = p * w, py = (s.y0 + s.dy * p) * h;
        if (p < -0.1 || p > 1.1) return;
        var blink = Math.floor(t * 1.4 + s.ph * 10) % 3 === 0 ? 1 : 0.45;
        var g = x.createRadialGradient(px, py, 0, px, py, 9); g.addColorStop(0, 'rgba(255,255,255,' + (0.9 * blink) + ')'); g.addColorStop(1, 'rgba(255,255,255,0)');
        x.fillStyle = g; x.beginPath(); x.arc(px, py, 9, 0, 6.283); x.fill();
        x.strokeStyle = 'rgba(255,255,255,.08)'; x.setLineDash([2, 6]); x.beginPath(); x.moveTo(px - 140, py - s.dy * h * 140 / w); x.lineTo(px, py); x.stroke(); x.setLineDash([]);
      });
    } else {
      x.drawImage(this.board, 0, 0, this.w, this.h);
      this.traces.forEach(function (tr) {
        if (!tr.hot) return;
        var cyc = (t * tr.sp + tr.ph) % 1, head = cyc * (tr.L + 80) - 40;
        for (var k = 0; k < 10; k++) {
          var d = head - k * 6; if (d < 0 || d > tr.L) continue;
          var p = along(tr, d), a = (1 - k / 10) * 0.55;
          x.fillStyle = 'rgba(' + tr.col + ',' + a.toFixed(3) + ')';
          x.beginPath(); x.arc(p[0], p[1], 2.2 - k * 0.12, 0, 6.283); x.fill();
        }
      });
    }
  };
  function initBgs(root) {
    (root || document).querySelectorAll('canvas[data-pdpx-canvas]').forEach(function (cv) {
      if (cv.pdpx) return; cv.pdpx = new CanvasBg(cv, cv.getAttribute('data-pdpx-canvas'));
    });
  }
  T.initBgs = initBgs;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initBgs(); }); else initBgs();
  document.addEventListener('shopify:section:load', function (e) { initBgs(e.target); });
})();
